import { createRouter, createWebHistory } from 'vue-router';
import AdminLayout from '@/layouts/AdminLayout.vue';
import DefaultLayout from '@/layouts/DefaultLayout.vue';
import HomePage from '@/views/HomePage.vue';
import Login from '@/components/Login.vue';
/*import Dashboard from '@/components/Dashboard.vue';
import AdvertisementList from '@/components/AdvertisementList.vue';
import AdvertisementForm from '@/components/AdvertisementForm.vue';
import CategoryList from '../components/CategoryList.vue';
import CouponList from '../components/CouponList.vue';
import CategoryForm from '../components/CategoryForm.vue';
import CouponForm from '../components/CouponForm.vue';*/
import ForgotPassword from '@/components/ForgotPassword.vue';
import RegisterUser from '@/components/RegisterUser.vue';
import OtpValidation from '@/components/OtpValidation.vue';
import Result from '@/components/Result.vue';
import Confirmation from '@/components/Confirmation.vue';
/*import ClientList from '@/components/ClientList.vue';
import ClientForm from '@/components/ClientForm.vue';
import UserList from '@/components/UserList.vue';
import UserForm from '@/components/UserForm.vue';
import EnterpriseList from '@/components/EnterpriseList.vue';
import EnterpriseForm from '@/components/EnterpriseForm.vue';
import EditAdvertisementForm from '@/components/EditAdvertisementForm.vue';
import RenewalAdvertisementForm from '@/components/RenewalAdvertisementForm.vue';
import SubscriptionsList from '@/components/SubscriptionsList.vue';
import SubscriptionForm from '@/components/SubscriptionForm.vue';*/
import ContactForm from '@/components/ContactForm.vue';
import ProjectsPage from '@/components/ProjectsPage.vue';
import RegisterProject from '@/components/RegisterProject.vue';
import Project from '@/components/Project.vue';
import ProjectList from '@/components/ProjectList.vue';
import ProposalList from '@/components/ProposalList.vue';
import FavoriteList from '@/components/FavoriteList.vue';
import UserProfile from '@/components/UserProfile.vue';
import FreelancerProfile from '@/components/FreelancerProfile.vue';
import ProjectPayment from '@/components/ProjectPayment.vue';
import Dispute from '@/components/Dispute.vue';

const PUBLIC_ROUTES = [
  'login',
  'forgot-password',
  'register',
  'otp-validation',
  'HomePage',
];

const routes = [
  {
    path: '/login',
    name: 'login',
    component: Login,
  },
  {
    path: '/esqueceu-senha',
    name: 'forgot-password',
    component: ForgotPassword,
  },
  {
    path: '/cadastro',
    name: 'register',
    component: RegisterUser,
  },
  {
    path: '/validar-codigo',
    name: 'otp-validation',
    component: OtpValidation,
  },
  {
    path: '/confirmacao/:reference/:hash',
    name: 'confirmation',
    component: Confirmation,
  },
  {
    path: '/',
    component: DefaultLayout,
    children: [
      {
        path: '/',
        name: 'HomePage',
        component: HomePage,
      },
      {
        path: "/contato",
        name: "Contato",
        component: ContactForm,
      },
      {
        path: '/projeto/:hash/:slug',
        name: 'detalhes',
        component: Project,
        props: true
      },
      {
        path: '/cadastre-seu-projeto',
        name: 'register-project',
        component: RegisterProject,
        meta: { requiresAuth: true },
      },
      {
        path: '/projetos/:hash/:slug/pagamento',
        name: 'project-payment',
        component: ProjectPayment,
      },
      {
        path: '/payment/result',
        name: 'PaymentResult',
        component: Result,
      },
      {
        path: '/disputas/:id',
        name: 'dispute',
        component: Dispute,
        meta: { requiresAuth: true }
      },
      {
        path: '/projetos',
        name: 'projects',
        component: ProjectsPage,
        meta: { requiresAuth: true },
      },
      {
        path: '/meus-projetos',
        name: 'project-list',
        component: ProjectList,
        meta: { requiresAuth: true },
      },
      {
        path: '/minhas-propostas',
        name: 'proposal-list',
        component: ProposalList,
        meta: { requiresAuth: true },
      },
      {
        path: '/favoritos',
        name: 'favorite-list',
        component: FavoriteList,
        meta: { requiresAuth: true },
      },
      {
        path: '/perfil',
        name: 'profile',
        component: UserProfile,
        meta: { requiresAuth: true },
      },
      {
        path: '/freelancer/:hash/:reference',
        name: 'freelancer',
        component: FreelancerProfile,
        meta: { requiresAuth: true },
      },
    ],
  },
  {
    path: '/app',
    component: AdminLayout,
    meta: { requiresAuth: true, adminOnly: true }, // 🔒 exige autenticação e role admin/administrative
    children: [
      /*{ path: 'dashboard', name: 'Dashboard', component: Dashboard },
      { path: 'anuncios', name: 'Anuncios', component: AdvertisementList },
      { path: 'anuncios/novo', name: 'advertisement-create', component: AdvertisementForm },
      { path: 'anuncios/editar/:id', name: 'advertisement-edit', component: AdvertisementForm, props: true },
      { path: 'categorias', name: 'Categorias', component: CategoryList },
      { path: 'categorias/novo', name: 'category-create', component: CategoryForm },
      { path: 'categorias/editar/:id', name: 'category-edit', component: CategoryForm, props: true },
      /*{ path: 'cupons', name: 'Cupons', component: CouponList },
      { path: 'cupons/novo', name: 'coupon-create', component: CouponForm },
      { path: 'cupons/editar/:id', name: 'coupon-edit', component: CouponForm, props: true },
      { path: 'usuarios', name: 'Usuários', component: UserList },
      { path: 'usuarios/novo', name: 'user-create', component: UserForm },
      { path: 'usuarios/editar/:id', name: 'user-edit', component: UserForm, props: true },
      { path: 'empresa', name: 'Empresa', component: EnterpriseList },
      { path: 'empresa/editar/:id', name: 'enterprise-edit', component: EnterpriseForm, props: true },
      { path: 'clientes', name: 'Clientes', component: ClientList },
      { path: 'clientes/novo', name: 'client-create', component: ClientForm },
      { path: 'clientes/editar/:id', name: 'client-edit', component: ClientForm, props: true },
      /*{ path: 'assinaturas', name: 'Assinaturas', component: SubscriptionsList },
      { path: 'assinaturas/novo', name: 'subscription-create', component: SubscriptionForm },
      { path: 'assinaturas/editar/:id', name: 'subscription-edit', component: SubscriptionForm, props: true },*/
    ],
  },
  {
    path: '/:pathMatch(.*)*',
    redirect: '/',
  },
];

const router = createRouter({
  history: createWebHistory(),
  routes,
});

router.beforeEach((to, from, next) => {
  const isAuthenticated = !!localStorage.getItem('userData');
  const user = JSON.parse(localStorage.getItem('userData') || '{}');
  const role = user?.user?.role;
  const requiresAuth = to.matched.some((record) => record.meta.requiresAuth);
  const adminOnly = to.matched.some((record) => record.meta.adminOnly);
  const routeName = to.name || '';

  // 🔒 Rota exige login
  if (requiresAuth && !isAuthenticated) {
    return next({ name: 'login', query: { redirect: to.fullPath } });
  }

  // 🚫 Bloqueia acesso a /app se não for admin/administrative
  if (adminOnly && !['admin', 'administrative'].includes(role)) {
    return next({ name: 'HomePage' });
  }

  /*// 🔁 Evita que usuários autenticados acessem rotas públicas (login, cadastro, etc.)
  if (isAuthenticated && PUBLIC_ROUTES.includes(routeName)) {
    if (role === 'client') {
      return next({ name: 'HomePage' });
    } else if (['admin', 'administrative'].includes(role)) {
      return next({ name: 'Dashboard' });
    }
  }*/

  next();
});

export default router;
